export default import.meta.ROLLUP_FILE_URL_OyF0PA4aRGMJqaedNGoe3g